module.exports = __webpack_public_path__ + "img/dizzy.41faee65.svg";